import { Close as CloseIcon } from '@mui/icons-material';
import { Box, Chip, IconButton, Stack, Typography } from '@mui/material';

import type { SteppedModalHeaderProps } from './types';

export const SteppedModalHeader: React.FC<SteppedModalHeaderProps> = ({ branding, onClose }) => {
  const Icon = branding.icon;

  return (
    <Box
      sx={{
        bgcolor: 'primary.main',
        color: 'primary.contrastText',
        px: 3,
        py: 2,
        position: 'relative',
      }}
    >
      <Stack direction="row" spacing={1.5} sx={{ alignItems: 'center' }}>
        <Icon sx={{ fontSize: 24 }} />
        <Typography variant="subtitle1" sx={{ fontWeight: 700 }}>
          {branding.name}
        </Typography>
        {branding.badge && (
          <Chip
            label={branding.badge}
            size="small"
            sx={{
              bgcolor: 'rgba(255,255,255,0.2)',
              color: 'inherit',
              fontWeight: 600,
              fontSize: '0.7rem',
              height: 24,
            }}
          />
        )}
      </Stack>
      <IconButton
        aria-label="close"
        onClick={onClose}
        sx={{
          position: 'absolute',
          right: 8,
          top: 8,
          color: 'inherit',
        }}
      >
        <CloseIcon />
      </IconButton>
    </Box>
  );
};
